<template>
  <button type="button" class="footer-menu-item" @click="$emit('select', item)">
    {{ item.label }}
  </button>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.footer-menu-item {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  margin: 0;
  font-family: $font-family-bold-book;
  font-size: 18px;
  font-weight: 400;
  cursor: pointer;
  letter-spacing: 0.15px;
  color: inherit;
  text-align: left;
  line-height: 1.5;
}

.footer-menu-item:hover {
  text-decoration: underline;
}

@media screen and (max-width: $media-md) {
  .footer-menu-item {
    font-size: 16px;
  }
}
</style>
